module.exports = __webpack_public_path__ + "static/media/Why-one.dce422b6.svg";